import { AngularFirestore } from "@angular/fire/compat/firestore";
import { Injectable } from "@angular/core";
import { Site } from "./company-site.model"
import { Subject, Subscription, combineLatest, of } from "rxjs";
import { ConfigService } from "src/app/shared/config";
import { NotificationService } from "src/app/shared/notification.service";
import { AuthService } from "src/app/services/auth.service";
import { AuditService } from "src/app/services/audit.service";
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { map } from "rxjs/operators";

// Yes/No system settings the app reads as the strings 'true' / 'false'.
const STRING_FLAG_FIELDS = [
    'needLogin', 'isCreditActive', 'isGroupSubsidyActive', 'isMVAActive',
    'isVippsActive', 'isCardActive', 'isGuestModeActive', 'checkStatus',
    'isHalalLogoActive', 'isNewLogoActive', 'isVegeterianLogoActive'
];

export interface CompanySite {
    siteId: string;
    name: string;
    location: string;
    url: string;
}


@Injectable({ providedIn: 'root' }) export class CompanysitesService {

    // companyId = "E1DJZVRUmaa7azB16NdQ"


    systemsArr = [];
    siteId: string;
    companyId: string;
    // siteChanged = new Subject<Site[]>();
    // siteChangedSystem = new Subject<{}>();
    companySites: Site[] = [];
    notficationsChange = new Subject();
    haveIsWatchedChange = new Subject();
    notifications = [];
    start = null      // start position of listener
    end = null

    //
    getSiteSystemsByIdSub = new Subscription()
    sites$;

    constructor(public auth: AuthService,
        private afs: AngularFirestore,
        private config: ConfigService,
        private audit: AuditService,
        private notifierService: NotificationService) {
    }


    getSites$() {
        return combineLatest(this.auth.user$, this.afs.collection("company").doc(this.config.getCompanyId()).collection('sites').snapshotChanges()).pipe(map(arr => {
            return arr[1].filter(sites => arr[0]['sites'].find(site => {
                return sites.payload.doc.id === site
            })).map(data => {
                return {
                    name: data.payload.doc.data()['name'],
                    siteId: data.payload.doc.id,
                    location: data.payload.doc.data()['location'],
                    url: '/dashboard/sites/' + data.payload.doc.id
                }
            })
        })
        )

    }

    siteSubj = new Subject();
    savedSites = [];

    getCompanySites$ = () => {

        if (this.savedSites.length == 0) {
            this.afs.collection("company").doc(this.config.getCompanyId()).collection('sites').ref.get().then((data) => {
                this.savedSites = data.docs;
                this.siteSubj.next(data.docs);
            })
        } else {
            setTimeout(() => {
                this.siteSubj.next(this.savedSites);
            }, 100);
        }


        return this.siteSubj;
    }


    addSite(site: Site) {


        site['isProjectActive'] = false;
        site['isDepartmentActive'] = false;
        site['isFreetextActive'] = false;
        site['strictGroup'] = false;

        // site['isKeyboardActive'] = JSON.parse(site['isKeyboardActive']);

        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites').add(site)
            .then((data) => {
                this.notifierService.showNotification('success', "Successfully added!");
            }).
            catch(err => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
            })
    }

    getSiteById(id: string) {
        return this.afs.collection("company").doc(this.config.getCompanyId()).collection('sites').doc(id).get();
    }


    getSiteRefById(id: string) {
        return this.afs.collection("company").doc(this.config.getCompanyId()).collection('sites').ref.doc(id).get();
    }

    onSiteDelete(siteId: string) {
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .delete()
            .then((data) => {
                this.notifierService.showNotification('success', "Successfully deleted!")
            }).catch(err => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
            })
    }

    getSiteSystemsByIdObs(siteId: string) {
        return this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .snapshotChanges()
            .pipe(map(data => {
                return data.map(doc => {
                    return {
                        name: doc.payload.doc.data()['name'],
                        systemId: doc.payload.doc.id,
                        createdAt: doc.payload.doc.data()['createdAt'],
                        url: '/dashboard/sites/' + siteId + '/system/' + doc.payload.doc.id
                    }

                })
            }));
    }

    getAllOverviewOfMachines$ = () => {
        return this.afs.collection('machineStatusForView').snapshotChanges().pipe(map(doc => {
            return doc.map(obj => {
                return {
                    ...obj.payload.doc.data() as object,
                    dbid: obj.payload.doc.id,
                    updatedOn: moment.unix(obj.payload.doc.data()['updatedOn']).tz('Europe/Oslo').fromNow()
                }
            })
        }))
    }

    async getSystemByNumber(systemNumber: number) {
        const querySnapshot = await this.afs.collection('system_info').ref.where('number', '==', systemNumber).get();
        if (!querySnapshot.empty) {
            return querySnapshot.docs[0].data();
        }
        return null;
    }

    getCompanySystems = () => {
        return this.afs.collection('system_info').ref.where('companyId', '==', this.config.getCompanyId()).where('active', '==', true).get();
    }

    dataSubj = new Subject();
    savedDocs = [];

    getCompanySystems$ = () => {


        if (this.savedDocs.length == 0) {
            // kantineAvailble is stored as the string "true"/"false" on most docs,
            // but some are a real boolean — a Firestore where('==', "true") only
            // matches the string, so a boolean-true doc silently disappears from
            // this list. Filter client-side instead so either type is included.
            this.afs.collection('system_info').ref.where('companyId', '==', this.config.getCompanyId()).get().then((data) => {

                this.savedDocs = data.docs.filter(doc => String(doc.data()['kantineAvailble']).toLowerCase() === 'true');
                this.dataSubj.next(this.savedDocs);
            })
        } else {
            setTimeout(() => {
                this.dataSubj.next(this.savedDocs);
            }, 100);
        }


        return this.dataSubj;
    }

    getComanySystemsStatus$ = () => {
        return this.afs.collection('system_status').snapshotChanges()
    }


    onUpdateSite(siteId: string, obj) {

        switch (obj['isProjectActive']) {
            case "OPEN":
                obj['isProjectActive'] = true;
                obj['projectNumbersStrict'] = false;
                break;
            case "STRICT":
                obj['isProjectActive'] = true;
                obj['projectNumbersStrict'] = true;
                break;
            case "NO":
                obj['isProjectActive'] = false;
                obj['projectNumbersStrict'] = false;
                break;
            default:
                this.notifierService.showNotification("error", "Unhandled project is active case: " + obj['isProjectActive']);
                return;
        }

        obj['isProjectActive'] = JSON.parse(obj['isProjectActive']);
        obj['isCategoryActive'] = JSON.parse(obj['isCategoryActive']);
        obj['isFreetextActive'] = JSON.parse(obj['isFreetextActive']);
        obj['projectNumbersStrict'] = JSON.parse(obj['projectNumbersStrict']);
        obj['strictGroup'] = JSON.parse(obj['strictGroup']);

        // Check if user tries to remove grups with department enabled
        if (obj['isDepartmentActive'] && (!obj['strictGroup'])) {
            this.notifierService.showNotification("info", "To disable User Group you need to disable departments frist");
        }

        // Enable grups if departments are enabled
        if (obj['isDepartmentActive']) obj['strictGroup'] = true;

        // obj['isKeyboardActive'] = JSON.parse(obj['isKeyboardActive']);
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .update(obj)
            .then((data) => {
                this.notifierService.showNotification('success', "Successfully updated!")
            }).catch(err => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
            })
    }




    async onDeleteSite(siteId: string) {
        const reason = await this.audit.promptDeleteReason('site', siteId);
        if (reason === null) return; // cancelled
        const ref = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId);
        await ref.update(this.audit.stamp('delete', reason));
        ref
            .delete()
            .then((data) => {
                this.notifierService.showNotification('success', "Successfully deleted!")
            }).catch(err => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
            })
    }



    /** Next free system number for this company: max(number) + 1, or null if the company has no systems yet. */
    async getNextSystemNumber(): Promise<number | null> {
        const snap = await this.afs.collection('system_info').ref
            .where('companyId', '==', this.config.getCompanyId()).get();
        let max = 0;
        snap.docs.forEach(d => {
            const n = Number(d.data()['number']);
            if (Number.isFinite(n) && n > max) max = n;
        });
        return max > 0 ? max + 1 : null;
    }

    async onSystemAddNew(formData, siteId) {
        const number = Number(formData.number);
        if (!Number.isInteger(number) || number <= 0) {
            this.notifierService.showNotification('error', 'Nummer must be a whole number');
            return;
        }
        const ip = (formData.ip || '').trim();

        const existing = await this.afs.collection('system_info').ref.where('number', '==', number).get();
        if (!existing.empty) {
            this.notifierService.showNotification('error', `System number ${number} is already registered. Please contact Admin`);
            return;
        }

        formData.number = number;
        formData.ip = ip;
        formData.ipAddress = ip ? `http://${ip}:8081` : '';
        formData.active = true;
        formData.lockerId = ""
        formData.vmachine = true;
        formData.locker = true;
        formData.emailsForStockFiller = []
        formData.emailsForFault = []
        formData.storageId = "";
        formData.defaultCustomerNumber = "";
        formData.createdAt = moment().unix();
        formData.companyId = this.config.getCompanyId();
        formData.siteId = siteId;
        formData.testChannelPort = "8081";
        formData.restartPort = "8082";
        formData = this.normalizePopupSettings(formData);

        const batch = this.afs.firestore.batch();

        const systemInfoRef = this.afs.collection('system_info').doc().ref;
        // systemId is the generated document id, shared by both documents.
        formData.systemId = systemInfoRef.id;
        batch.set(systemInfoRef, formData);

        const systemRef = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemInfoRef.id).ref;

        batch.set(systemRef, formData);

        batch.commit().then((data) => {
            this.notifierService.showNotification('success', "Successfully added!")
        }).catch(err => {
            this.notifierService.showNotification('error', "Some problem happend! try again");
        })
    }

    getSystemRefById(siteId: string, systemId: string) {
        return this.afs.collection('system_info').ref.doc(systemId).get();

        // return this.afs.collection("company").
        // doc(this.config.getCompanyId()).
        // collection('sites')
        // .doc(siteId).collection('systems').ref.doc(systemId).get();
    }

    // companyId: the system's own company when it can differ from the one
    // selected in the admin (the kundekort lists systems across companies).
    onUpdateSystem(siteId: string, systemId: string, obj, companyId?: string) {
        obj = this.normalizePopupSettings(obj);

        // A field left empty in the popup (Customer reference, Garantiomsetning,
        // Description...) arrives as `undefined` when the system never had one.
        // Firestore refuses the WHOLE write over a single undefined value, and
        // batch.update() throws synchronously — outside the .catch below — so the
        // save failed silently and even a rename didn't stick. Drop those keys;
        // text fields are trimmed so a blank reference is stored as '' and the
        // invoice falls back to the customer's own default.
        obj = Object.keys(obj).reduce((out, k) => {
            const v = obj[k];
            if (v === undefined) { return out; }
            out[k] = typeof v === 'string' ? v.trim() : v;
            return out;
        }, {} as any);

        const batch = this.afs.firestore.batch();

        // set/merge, not update: a system without a system_info doc yet would
        // otherwise fail the batch with NOT_FOUND and lose the site-side edit too.
        const systemInfoRef = this.afs.collection('system_info').doc(systemId).ref;
        batch.set(systemInfoRef, obj, { merge: true });

        const systemRef = this.afs.collection('company')
            .doc(companyId || this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId).ref;

        batch.update(systemRef, obj);

        batch.commit().then((data) => {
            this.notifierService.showNotification('success', "Successfully updated!")
        }).catch(err => {
            this.notifierService.showNotification('error', "Some problem happend! try again");
        })
    }

    private normalizePopupSettings(data) {
        const popupType = data['popupType'] || 'warning';
        const normalized = {
            ...data,
            popupType,
            windowColor: data['windowColor'] || '#f59e0b'
        };

        // The app compares these with === 'true'. The popup <select> returns
        // strings for an option the user picks, but a pre-filled default the
        // user leaves untouched stays a boolean, so a new system could be
        // saved with isVippsActive: true and show no payment method (1064).
        for (const key of STRING_FLAG_FIELDS) {
            if (typeof normalized[key] === 'boolean') {
                normalized[key] = String(normalized[key]);
            }
        }

        return normalized;
    }

    async onDeleteSystem(systemId: string, siteId: string) {
        const reason = await this.audit.promptDeleteReason('system', systemId);
        if (reason === null) return; // cancelled
        const ref = this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('sites')
            .doc(siteId)
            .collection('systems')
            .doc(systemId);
        await ref.update(this.audit.stamp('delete', reason));
        ref
            .delete()
            .then((data) => {
                this.notifierService.showNotification('success', "Successfully deleted!")
            }).catch(err => {
                this.notifierService.showNotification('error', "Some problem happend! try again");
            })
    }




    getNotification() {
        this.notifications = [];
        let haveToWatched: boolean = true;
        this.afs.collection('company')
            .doc(this.config.getCompanyId())
            .collection('notifications')
            .ref
            .orderBy("createdAt", "desc")
            .limit(5)
            .onSnapshot((snapshot) => {
                this.start = snapshot.docs[snapshot.docs.length - 1]
                snapshot.docChanges().forEach((change) => {
                    if (change.type === "added") {
                        change.doc.data()['id'] = change.doc.id;
                        if (haveToWatched)
                            haveToWatched = change.doc.data()['isWatched'];

                        this.notifications.push(change.doc.data())
                    }
                });
                this.notficationsChange.next(this.notifications);
                this.haveIsWatchedChange.next(haveToWatched);
            })
    }


    getMoreNotification() {
        if (this.start != undefined) {
            let haveToWatched: boolean = true;
            this.afs.collection('company')
                .doc(this.config.getCompanyId())
                .collection('notifications')
                .ref
                .orderBy("createdAt", "desc")
                .limit(5)
                .startAfter(this.start)
                .get()
                .then((snapshot) => {
                    this.start = snapshot.docs[snapshot.docs.length - 1]

                    snapshot.forEach((doc) => {
                        doc.data()['id'] = doc.id;
                        if (haveToWatched)
                            haveToWatched = doc.data()['isWatched'];
                        this.notifications.push(doc.data())
                    });
                    this.notficationsChange.next(this.notifications);
                    this.haveIsWatchedChange.next(haveToWatched);
                })
        }
    }

    areWatched() {
        let path = this.afs.collection('company').doc(this.config.getCompanyId()).collection('notifications');
        path.ref.where('isWatched', '==', false).get().then((querySnapshot) => {
            querySnapshot.forEach(function (doc) {
                let notiRef = path.doc(doc.id);

                return notiRef.update({
                    isWatched: true
                });
            });
        });
    }


}